import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import EducationalDisclaimer from '@/components/feature/EducationalDisclaimer';

const NevadaCommercialVehiclePage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <section className="pt-28 pb-12 bg-obsidian-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center space-x-2 text-sm text-obsidian-400 mb-4">
          <Link to="/" className="hover:text-gold-400">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/nevada-dmv-info" className="hover:text-gold-400">DMV Info</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-gold-400">Commercial Vehicle Registration</span>
        </div>
        <h1 className="font-display text-4xl font-bold text-white mb-3">Nevada Commercial Vehicle Registration</h1>
        <p className="text-obsidian-300">Requirements for registering commercial vehicles, fleets, and trucks in Nevada.</p>
      </div>
    </section>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <EducationalDisclaimer />
      <div className="space-y-8 text-obsidian-700">
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">Commercial Vehicle Overview</h2>
          <p>Commercial vehicles in Nevada are subject to different registration requirements than standard passenger vehicles. Vehicles over <strong>26,001 lbs GVWR</strong> or used in interstate commerce are handled by the Nevada Motor Carrier Division.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">Registration Categories</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { title: 'Standard Commercial', desc: 'Vehicles under 26,001 lbs used for business purposes. Registered through standard DMV process.' },
              { title: 'Motor Carrier (Heavy)', desc: 'Vehicles 26,001 lbs or more, or interstate commerce vehicles. Handled by Motor Carrier Division.' },
              { title: 'International Registration Plan (IRP)', desc: 'For commercial vehicles operating in multiple states. Allows proportional registration.' },
              { title: 'Fleet Registration', desc: 'Streamlined process for businesses registering multiple vehicles simultaneously.' },
            ].map(item => (
              <div key={item.title} className="border border-obsidian-100 rounded-lg p-4">
                <p className="font-semibold text-obsidian-900 text-sm mb-1">{item.title}</p>
                <p className="text-obsidian-500 text-xs">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">CDL Requirements</h2>
          <ul className="space-y-2">
            {['Must be 21 years old (18 for intrastate only)', 'Pass knowledge and skills tests', 'Complete mandatory Entry-Level Driver Training (ELDT)', 'Maintain a valid medical certificate', 'Pass drug and alcohol testing'].map(item => (
              <li key={item} className="flex items-start space-x-3 text-sm">
                <i className="ri-checkbox-circle-line text-green-500 flex-shrink-0 mt-0.5"></i><span>{item}</span>
              </li>
            ))}
          </ul>
        </section>
        <div className="bg-gold-50 border border-gold-200 rounded-xl p-6 text-center">
          <h3 className="font-display font-bold text-obsidian-900 text-lg mb-2">Commercial Vehicle Questions?</h3>
          <p className="text-obsidian-600 text-sm mb-4">Contact Speedy DMV Services for guidance on commercial vehicle registration in Nevada.</p>
          <Link to="/contact" className="inline-block bg-gold-gradient text-obsidian-900 px-6 py-2.5 rounded-lg font-bold text-sm hover:brightness-110 transition-all whitespace-nowrap">Contact Us</Link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default NevadaCommercialVehiclePage;
